// extracted by mini-css-extract-plugin
module.exports = {"instagramFeed":"styles-module--instagramFeed--1xwGh","instagramList":"styles-module--instagramList--1KcDw","title":"styles-module--title--2BkW6"};